import React from "react";
import ReactDOM from "react-dom";
import Customizer from "./Customizer";
import lodash from "lodash";
import EventsListDefinitions from "./definitions/EventsList/index";
import RegistrationsListDefinitions from "./definitions/RegistrationsList/index";
import GroupsListDefinitions from "./definitions/GroupsList/index";
import CalendarDefinitions from "./definitions/Calendar/index";

// Events Widget Customizers

let eventsCustomizers = document.querySelectorAll(
	"[data-widget=events-customizer]"
);

for (const eventsCustomizer of eventsCustomizers) {
	console.log(eventsCustomizer.dataset);

	if (lodash.get(eventsCustomizer.dataset, "pcoplusKey")) {
		ReactDOM.render(
			<React.StrictMode>
				<Customizer
					definitions={EventsListDefinitions}
					attributes={{ ...eventsCustomizer.dataset }}
				/>
			</React.StrictMode>,
			eventsCustomizer
		);
	}
}

// Registrations Widget Customizers

let registrationsCustomizers = document.querySelectorAll(
	"[data-widget=registrations-customizer]"
);

for (const registrationsCustomizer of registrationsCustomizers) {
	console.log(registrationsCustomizer.dataset);

	if (lodash.get(registrationsCustomizer.dataset, "pcoplusKey")) {
		ReactDOM.render(
			<React.StrictMode>
				<Customizer
					definitions={RegistrationsListDefinitions}
					attributes={{ ...registrationsCustomizer.dataset }}
				/>
			</React.StrictMode>,
			registrationsCustomizer
		);
	}
}

// Calendar Widget Customizers

let calendarCustomizers = document.querySelectorAll(
	"[data-widget=calendar-customizer]"
);

for (const calendarCustomizer of calendarCustomizers) {
	console.log(calendarCustomizer.dataset);

	if (lodash.get(calendarCustomizer.dataset, "pcoplusKey")) {
		ReactDOM.render(
			<React.StrictMode>
				<Customizer
					definitions={CalendarDefinitions}
					attributes={{ ...calendarCustomizer.dataset }}
				/>
			</React.StrictMode>,
			calendarCustomizer
		);
	}
}

// Groups Widget Customizers

let groupsCustomizers = document.querySelectorAll(
	"[data-widget=groups-customizer]"
);

for (const groupsCustomizer of groupsCustomizers) {
	console.log(groupsCustomizer.dataset);

	if (lodash.get(groupsCustomizer.dataset, "pcoplusKey")) {
		ReactDOM.render(
			<React.StrictMode>
				<Customizer
					definitions={GroupsListDefinitions}
					attributes={{ ...groupsCustomizer.dataset }}
				/>
			</React.StrictMode>,
			groupsCustomizer
		);
	}
}
